// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2BMKv","left":"StickyBox_left__mbuvB","right":"StickyBox_right__3g6Ij"};